import React, { useState } from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import Sidebar from "../components/shell/Sidebar";
import { useAuth } from "../contexts/AuthContext";
import { http } from "../lib/http";
import { Menu, X } from "lucide-react";
import { useEffect } from "react";

export default function AppShell() {
  const { user, loading } = useAuth();
  const location = useLocation();
  const [permissions, setPermissions] = useState({});
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    if (!user) return;
    http.get(`/auth/permissions`).then((r) => setPermissions(r.data.permissions || {})).catch(() => setPermissions({}));
  }, [user?.role]);

  // Close drawer on route change
  useEffect(() => { setMobileOpen(false); }, [location.pathname]);

  if (loading) {
    return <div className="min-h-screen flex items-center justify-center bg-brand-offWhite text-brand-navy">Loading…</div>;
  }
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return (
    <div className="min-h-screen flex bg-[#F7F8FA]" data-testid="app-shell">
      {/* Sidebar — fixed on md+, slide-over on mobile.
          aria-hidden is set only when the mobile drawer is closed; on md+ the
          sidebar is statically visible so the attribute is omitted. */}
      <div
        aria-hidden={mobileOpen ? undefined : "true"}
        className={`fixed md:static md:!translate-x-0 inset-y-0 left-0 z-40 transform transition-transform duration-200 ${mobileOpen ? "translate-x-0" : "-translate-x-full"}`}
      >
        <Sidebar permissions={permissions} />
      </div>
      {/* Backdrop for mobile drawer */}
      {mobileOpen && (
        <div className="fixed inset-0 z-30 bg-black/40 md:hidden" onClick={() => setMobileOpen(false)} data-testid="mobile-backdrop"/>
      )}
      <main className="flex-1 min-w-0">
        {/* Mobile top bar with hamburger */}
        <div className="md:hidden sticky top-0 z-20 bg-white border-b border-slate-200 flex items-center px-3 py-2">
          <button
            onClick={() => setMobileOpen(v => !v)}
            aria-label="Toggle navigation"
            className="p-2 rounded hover:bg-slate-100"
            data-testid="mobile-menu-toggle"
          >
            {mobileOpen ? <X size={20}/> : <Menu size={20}/>}
          </button>
          <div className="ml-2 text-sm font-heading text-brand-navy">
            The English Academy
          </div>
        </div>
        <Outlet context={{ permissions }} />
      </main>
    </div>
  );
}
